/**
 * Authentication initialization utility
 * Handles restoring authentication state on app startup
 */

/**
 * Initialize authentication state from localStorage
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Object|null} - User object if authenticated, null otherwise
 */
export const initializeAuth = (dispatch) => {
  try {
    // Check for existing token in localStorage
    const token = localStorage.getItem("@getGeek/token");
    
    if (token) {
      // If token exists, try to restore user state
      // You might want to validate the token with the backend here
      const userData = {
        id: "authenticated_user", // You might want to get this from token or API
        email: "authenticated_user", // You might want to get this from token or API
        isAuthenticated: true,
        token: token
      };
      
      // Dispatch action to set user in Redux store
      dispatch({ type: 'auth/updateUserManually', payload: userData });
      
      return userData;
    }
    
    return null;
  } catch (error) {
    console.error("Error initializing authentication:", error);
    return null;
  }
};

/**
 * Clear authentication state
 * @param {Function} dispatch - Redux dispatch function
 */
export const clearAuth = (dispatch) => {
  try {
    // Clear token from localStorage
    localStorage.removeItem("@getGeek/token");
    
    // Dispatch logout action
    dispatch({ type: 'auth/logout' });
    
    console.log("Authentication cleared successfully");
  } catch (error) {
    console.error("Error clearing authentication:", error);
  }
};
